import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { PageHeader } from "@ant-design/pro-components";
import { NotificationFilled } from "@ant-design/icons/lib/icons";
import { Alert, Button, Card, Form, Input, Spin, Tag } from "antd";
import { memo, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api/api";
import {
  normalizeReceiverList,
  notificationTitle,
} from "../../../Util/notificationReceivers";
import styles from "./NotificationReceiverEdit.module.css";

const MAX_RECEIVERS = 30;

const NotificationReceiverEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [key, setKey] = useState("");
  const [messageText, setMessageText] = useState("");
  const [active, setActive] = useState(true);
  const [mobiles, setMobiles] = useState([]);
  const [result, setResult] = useState({ message: "", type: "" });

  useEffect(() => {
    setLoading(true);
    setLoaded(false);
    api
      .get("/notification/details/" + id)
      .then((res) => {
        const data = res.data?.data;
        if (!data) {
          setResult({ message: "اعلان پیدا نشد.", type: "error" });
          return;
        }
        setKey(data.key || "");
        setMessageText(data.message || "");
        setActive(Boolean(data.active));
        setMobiles(Array.isArray(data.mobiles) ? data.mobiles : []);
        setLoaded(true);
      })
      .catch((error) => {
        setResult({
          message:
            error.response?.data?.error?.message || "خطا در دریافت اعلان",
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  }, [id]);

  const updateMobile = (index, value) => {
    setMobiles((current) =>
      current.map((mobile, itemIndex) =>
        itemIndex === index ? value : mobile
      )
    );
  };

  const removeMobile = (index) => {
    setMobiles((current) =>
      current.filter((_, itemIndex) => itemIndex !== index)
    );
  };

  const save = () => {
    const parsed = normalizeReceiverList(mobiles);
    if (parsed.error) {
      setResult({ message: parsed.error, type: "error" });
      return;
    }

    setSaving(true);
    setResult({ message: "", type: "" });
      api
      .post("/notification/subscribers/" + id, { mobiles: parsed.mobiles })
      .then((res) => {
        setSaving(false);
        if (res.data?.status === "success") {
          setMobiles(parsed.mobiles);
          setResult({ message: "ویرایش با موفقیت انجام شد.", type: "success" });
        } else {
          setResult({
            message: "مشکلی در ویرایش پیش آمده است.",
            type: "error",
          });
        }
      })
      .catch((error) => {
        setSaving(false);
        setResult({
          message:
            error.response?.data?.error?.message ||
            "مشکلی در ویرایش پیش آمده است.",
          type: "error",
        });
      });
  };

  const title = notificationTitle(key);

  return (
    <div>
      <PageHeader
        title={"ویرایش گیرندگان" + (title ? " " + title : "")}
        avatar={{
          icon: <NotificationFilled />,
          size: "large",
        }}
      />

      <Card className={styles.form}>
        {loading ? (
          <Spin />
        ) : !loaded ? (
          result.message && <Alert message={result.message} type={result.type} />
        ) : (
          <Form layout="vertical" autoComplete="off">
            <Form.Item label="عنوان">
              <Input value={title} disabled />
            </Form.Item>

            <Form.Item label="کلید">
              <Input value={key} disabled dir="ltr" />
            </Form.Item>

            <Form.Item label="متن پیام">
              <div className={styles.message}>
                {messageText || "متنی ثبت نشده است."}
              </div>
            </Form.Item>

            {!active && (
              <Alert
                style={{ marginBottom: 16 }}
                type="warning"
                showIcon
                message="این اعلان غیرفعال است و پیامک ارسال نمی‌شود."
              />
            )}

            <div>
              <span>شماره‌های موبایل</span>
              <span className={styles.hint}>
                پیام این اعلان برای این شماره‌ها ارسال می‌شود. می‌توانید همه
                گیرنده‌ها را حذف کنید.
              </span>
              {mobiles.map((mobile, index) => (
                <div className={styles.row} key={index}>
                  <Input
                    value={mobile}
                    placeholder="09123456789"
                    onChange={(event) => updateMobile(index, event.target.value)}
                  />
                  <Button
                    icon={<DeleteOutlined />}
                    aria-label={"حذف " + (mobile || index)}
                    onClick={() => removeMobile(index)}
                  />
                </div>
              ))}
              <Button
                icon={<PlusOutlined />}
                disabled={mobiles.length >= MAX_RECEIVERS}
                onClick={() => setMobiles((current) => [...current, ""])}
              >
                افزودن شماره
              </Button>
            </div>

            <div className={styles.actions}>
              <Button type="primary" loading={saving} onClick={save}>
                ذخیره
              </Button>
              <Button onClick={() => navigate("/notifications")}>بازگشت</Button>
            </div>

            {result.message && (
              <Alert
                style={{ marginTop: 16 }}
                message={result.message}
                type={result.type}
              />
            )}
          </Form>
        )}
      </Card>
    </div>
  );
};

export default memo(NotificationReceiverEdit);
